import { notification } from "antd";
import axios from "axios";
import { useCallback, useEffect, useState } from "react"
import { urlIconeModulo } from "../../services/request/urls";
import { getToken } from "../../services/token";

interface IIconeModulo {
    id: number;
    nome: string;
    file: string;
}


export default function useIconPicker({onChange, value}: any) {

    const [loadingData, setLoadingData] = useState(false);
    const [iconesModulo, setIconesModulo] = useState<IIconeModulo[]>([]);
    const [visible, setVisible] = useState(false);
    const [selectedIcon, setSelectedIcon] = useState<IIconeModulo>();
    const [searchTerm, setSearchTerm] = useState('');



    useEffect(() => {
        if (value && iconesModulo) {
            const icone = iconesModulo.find(icon => icon.id === value);
            setSelectedIcon(icone);
        }
    }, [value, iconesModulo]);

    const handleSelect = useCallback((iconName: string) => {
        const icone = iconesModulo.find(icon => icon.nome === iconName);
        if (!icone) {
            return;
        }

        onChange?.(icone.id);
        setSelectedIcon(icone);
        setVisible(false);
    }, [onChange, iconesModulo]);

    const filteredIcons = iconesModulo.filter(iconName =>
        iconName.nome.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        setLoadingData(true);
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlIconeModulo,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });

                setIconesModulo(result.data);
                setLoadingData(false);

            } catch (error) {
                setLoadingData(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        buscaDeDados();

    }, []);


    return {
        iconesModulo,
        loadingData,
        selectedIcon,
        setVisible,
        visible,
        searchTerm,
        setSearchTerm,
        filteredIcons,
        handleSelect
    }

}
